<template>
  <div class="event-filter">
    <NorticTextInput
      v-model="filter.text"
      placeholder="Filtrera"
      :is-validator-box-visible="false"
    />
    <NorticCheckbox v-model="filter.onlyActive">
      Endast aktiva
    </NorticCheckbox>
  </div>
</template>

<script>
import NorticCheckbox from '@/components/common/input/selection/checkbox/nortic-checkbox/NorticCheckbox.vue';
import NorticTextInput from '@/components/common/input/text-input/NorticTextInput.vue';

export default {
  name: 'EventFilter',
  components: { NorticTextInput, NorticCheckbox },
  props: {
    initialFilter: {
      type: Object,
      default: () => ({
        text: '',
        onlyActive: true,
      }),
    },
  },
  data() {
    return {
      filter: this.initialFilter,
    };
  },
  watch: {
    filter: {
      deep: true,

      handler() {
        this.emitFilterUpdateEvent();
      },
    },
  },
  methods: {
    emitFilterUpdateEvent() {
      this.$emit('filter-update', this.filter);
    },
  },
  mount() {
    this.emitFilterUpdateEvent();
  },
};
</script>

<style lang="scss" scoped>
  .event-filter {
    display: grid;
    grid-template-columns: 1fr minmax(100px, 120px);
    align-items: center;
    grid-gap: 10%;
    padding: 10px;
  }
</style>
